import { render, staticRenderFns } from "./StudyNavigation.vue?vue&type=template&id=48d2c118&scoped=true&"
import script from "./StudyNavigation.vue?vue&type=script&lang=js&"
export * from "./StudyNavigation.vue?vue&type=script&lang=js&"
import style0 from "./StudyNavigation.vue?vue&type=style&index=0&id=48d2c118&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2c118",
  null
  
)

export default component.exports